import { ADMIN_DASHBOARD_COPY } from '@sonar-software/sonar-ts-constants';
import { Button } from 'antd';
import { OidcProviderType } from '@sonar-software/sonar-security';
import { AzureIcon, GoogleIcon, OktaIcon, OneLoginIcon } from '.';
import React, { useCallback } from 'react';

export interface OidcProviderSetupSelectorProps {
	onProviderSelected?: (provider: OidcProviderType) => void;
}

export const OidcProviderSetupSelector: React.FC<OidcProviderSetupSelectorProps> = (props) => {
	const { onProviderSelected } = props;

	const handleClick = useCallback((provider: OidcProviderType) => {
		if (onProviderSelected) {
			onProviderSelected(provider);
		}
	}, [ onProviderSelected ]);

	return (
		<div>
			<Button
				className='oidc-provider-selection-btn'
				icon={ <OktaIcon /> }
				onClick={ () => handleClick('okta') }>
				{ ADMIN_DASHBOARD_COPY.ADD_OKTA_CONFIG }
			</Button>
			<Button
				className='oidc-provider-selection-btn'
				icon={ <AzureIcon /> }
				onClick={ () => handleClick('azure') }>
				{ ADMIN_DASHBOARD_COPY.ADD_AZURE_CONFIG }
			</Button>
			<Button
				className='oidc-provider-selection-btn'
				icon={ <GoogleIcon /> }
				onClick={ () => handleClick('google') }>
				{ ADMIN_DASHBOARD_COPY.ADD_GOOGLE_CONFIG }
			</Button>
			<Button
				className='oidc-provider-selection-btn'
				icon={ <OneLoginIcon /> }
				onClick={ () => handleClick('onelogin') }>
				{ ADMIN_DASHBOARD_COPY.ADD_ONELOGIN_CONFIG }
			</Button>
		</div>
	);
};
